import { Scrollbar } from '@aibees/shared/components';
import { TableLayoutTemplateItemDefault } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/components/table-layout-template-item-default';
import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import { useShowDefaultTemplateItem } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/hooks/use-show-default-template-item';
import { classnames } from '@aibees/shared/utils';
import {
  Box,
  FormControl,
  RadioGroup,
  RadioGroupProps,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import { TableLayoutTemplateItem } from '../table-layout-template-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableLayoutTemplateListProps as Props } from './types';

export const TableLayoutTemplateList = memo(({ className, items }: Props) => {
  const { id, setId } = useTableLayoutTemplateContext();
  const showDefault = useShowDefaultTemplateItem();

  const handleSelect: RadioGroupProps['onChange'] = (event, checked) => {
    if (checked.length) setId(event.target.value);
    else setId(undefined);
  };

  const hasTemplates = showDefault || items.length > 0;

  return (
    <Styled.Wrapper
      className={classnames('TableLayoutTemplateList', className)}
      sx={SX.root}
    >
      <Scrollbar
        sx={{ height: '115px', '.simplebar-content-wrapper': { py: 1 } }}
      >
        <FormControl sx={{ width: '100%' }}>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={id}
            onChange={handleSelect}
          >
            <Stack gap={0.75}>
              {showDefault && <TableLayoutTemplateItemDefault />}
              {items.map((item) => (
                <TableLayoutTemplateItem key={item.name} item={item} />
              ))}
              {!hasTemplates && (
                <Box sx={SX.noDataTitleBox}>
                  <Typography sx={SX.noDataTitle}>
                    No Templates Found
                  </Typography>
                </Box>
              )}
            </Stack>
          </RadioGroup>
        </FormControl>
      </Scrollbar>
    </Styled.Wrapper>
  );
});

TableLayoutTemplateList.displayName = 'TableLayoutTemplateList';
